<template>
  <div class="event-select-container">
    <div class="tournament-title">EVENTS</div>

    <div class="tournament-select">
      <div v-for="(tournament, index) in tournamentData" :key="index">
        <div v-if="tournament.dataAvailable === false">
          <div
            class="event-button disabled no-data"
            @click="selectTournament(tournament.id)"
            v-bind:class="{'selected': tournamentId==tournament.id}"
          >
            <div class="event-button-inner glow-border  ">{{tournament.venue}}</div>
          </div>

          <!-- <button class="disabled no-data">{{ tournament.venue }}</button> -->
          Data not available
        </div>

        <div v-else>
          <!-- <button @click="selectTournament(tournament.id)">{{ tournament.venue }}</button> -->

          <div
            class="event-button "
            @click="selectTournament(tournament.id)"
            v-bind:class="{'selected': tournamentId==tournament.id}"
          >
            <div class="event-button-inner glow-border">{{tournament.venue}}</div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="tournamentId" class="match-type-selector">
      <div>
        <div
          class="match-type-button"
          @click="selectMatchType('live')"
          v-bind:class="{'selected': matchType=='live'}"
        >
          <div class="match-type-button-inner glow-border">Live Matches</div>
        </div>
      </div>
      <div>
        <div
          class="match-type-button"
          @click="selectMatchType('completed')"
          v-bind:class="{'selected': matchType=='completed'}"
        >
          <div class="match-type-button-inner glow-border">Completed Matches</div>
        </div>
      </div>
    </div>

    <!-- Show matches for the selected match type "Live " or "Completed" -->
    <live-matches v-if="matchType=='live'" v-bind:tournament-id="tournamentId"></live-matches>
    <completed-matches v-if="matchType=='completed'" v-bind:tournament-id="tournamentId"></completed-matches>
  </div>
</template>

<script>
//const aelogo = require("@/assets/aegraphics_logo.png");
import CompletedMatches from "./CompletedMatches.vue";
import LiveMatches from "./LiveMatches.vue";

export default {
  name: "EventSelect",
  props: {
    tournamentData: Array
  },
  components: {
    "completed-matches": CompletedMatches,
    "live-matches": LiveMatches
  },
  data: () => ({
    tournamentId: "",
    key: "",
    matchType: "",
    notLoadedIds: ""
  }),
  mounted() {
    // console.log("EventSelect");
    this.$store.dispatch("setCurrentScreen", "event-select");
    //console.log(this.tournamentData);
  },
  watch: {
    notLoadedIds() {
      console.log(this.notLoadedIds);
      return this.$store.getters.notLoadedId;
    }
  },
  computed: {
    notLoadedId() {
      return this.$store.getters.notLoadedIds;
    }
  },

  methods: {
    selectTournament(id) {
      this.$store.dispatch("setTournamentId", id);
      this.tournamentId = id;
      console.log("EventSelect: tournamentId = " + id);
    },

    selectMatchType(type) {
      // LiveScores or CompletedMatches
      this.$store.dispatch("setMatchType", type);
      this.matchType = type;
      console.log("EventSelect: matchType = " + this.matchType);
    }
  }
};
</script>

<style scoped>
.event-button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #000;
  padding: 0.25rem;
  width: 20rem;
  height: 4rem;
  line-height: 4rem;
  margin: 0.25rem;
  visibility: hidden;
}


.event-button.selected {
  visibility: visible;
  box-shadow: 0 0 10px rgba(0, 224, 155, 0.6), 
              0 0 20px rgba(0, 224, 155, 0.5), 
              0 0 40px rgba(0, 224, 155, 0.4);
  border-radius: 12px; 

}

.event-button-inner {
  width: 100%;
  height: 4rem;
  line-height: 4rem;
  color: #ffffff;
  background-color: #000000;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.5rem;
  visibility: visible;
  cursor:pointer;

}
.event-button-inner:hover{
  background: linear-gradient(to right, #01d16dce, #00edc9c4);
   color: #4b006e; 
}

.event-select-container {
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  font-family: "GeneralSans Medium";
  
  
}

.tournament-title {
  font-weight: 400;
  font-size: 3rem;
}

.tournament-select {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* button {
  color: #000;
  background-color: #e1e1e1;
  text-transform: uppercase;
  width: 20rem;
  height: 4rem;
  font-weight: 400;
  font-size: 1.5rem;
  margin: 0.25rem;
} */

.match-type-selector {
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
}

.match-type-button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  padding: 0.25rem;
  width: 16rem;
  height: 2.75rem;
cursor:pointer;
  margin: 0.25rem;
  visibility: hidden;
  border-radius: 0.5rem;

}

.match-type-button.selected {
  visibility: visible;
  box-shadow: 0 0 10px rgba(0, 224, 155, 0.6), 
              0 0 20px rgba(0, 224, 155, 0.5), 
              0 0 40px rgba(0, 224, 155, 0.4);
  border-radius: 12px; 
}

.match-type-button-inner {
  width: 100%;
  height: 100%;
  line-height: 2.75rem;
  background-color: #000;
  color: #fff;
  text-transform: uppercase;
  font-weight: 400;
  font-size: 1.25rem;
  visibility: visible;
}
.match-type-button-inner:hover{
  background: linear-gradient(to right, #01d16dce, #00edc9c4);
   color: #4b006e; 
}

/* .match-type-selector button {
  color: #fff;
  background-color: #000;
}

.match-type-selector button.selected {
  color: red;
} */

/* .event {
  margin: auto;
} */

.disabled {
  opacity: 0.25;
  pointer-events: none;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.glow-border {
  position: relative;
  border-radius: 12px;
  padding: 0px;
  background-color: black; /* Change as needed */
  overflow: hidden;
  cursor: pointer; /* Show it's clickable */
}

/* Neon glow at the top center */
.glow-border::before {
  content: "";
  position: absolute;
  top: -5px;
  left: 50%;
  width: 60%;
  height: 20px;
  background: radial-gradient(circle, rgba(0, 231, 179, 0.9) 10%, transparent 80%);
  transform: translateX(-50%);
  filter: blur(12px);
  pointer-events: none; /* Fix: Allows clicks */
}

/* Linear gradient border */
.glow-border::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 2px; /* Border thickness */
  mask: linear-gradient(to bottom right, 
    rgba(0, 231, 179, 1) 5%, 
    rgb(0, 102, 82) 40%, 
    transparent 60%, 
    transparent 100%);
  border: 2px solid rgba(0, 231, 179, 1);
  filter: blur(3px);
  pointer-events: none; /* Fix: Allows clicks */
}

/* Example: Click effect */
.glow-border:active {
  transform: scale(0.98);
  transition: transform 0.1s ease;
}
</style>